<div #dmPortal class="cv-body-portal">
  <div
    class="cv-dm-backdrop"
    *ngIf="isOpen && geospatialPanelVisible()"
    (click)="onBackdropClick($event)"
  >
    <div
      class="cv-dm-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cv-dm-title"
    >
      <!-- Header -->
      <div class="cv-dm-header cv-dm-header--divider">
        <h2 class="cv-dm-header__title" id="cv-dm-title">
          Geospatial Datasets
        </h2>
        <button
          class="cv-dm-header__close"
          (click)="closeModal.emit()"
          title="Close"
          type="button"
          aria-label="Close"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <!-- Search & Actions row -->
      <div class="cv-dm-search-row">
        <div class="cv-dm-search">
          <svg
            class="cv-dm-search__icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            class="cv-dm-search__input"
            type="text"
            placeholder="Explore datasets"
            [value]="searchQuery()"
            (input)="onSearchInput($event)"
            autocomplete="off"
          />
        </div>

        <button
          class="cv-dm-search-row__icon-btn"
          [class.cv-dm-search-row__icon-btn--active]="isFilterPanelOpen()"
          (click)="toggleFilterPanel()"
          title="Filter datasets"
          type="button"
          [attr.aria-expanded]="isFilterPanelOpen()"
          aria-controls="cv-dm-filter-panel"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
        </button>

        <button
          class="cv-dm-search-row__bbox-btn"
          title="Bounding box search"
          type="button"
          (click)="onBboxSearchClick()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M3 7V5a2 2 0 0 1 2-2h2" />
            <path d="M17 3h2a2 2 0 0 1 2 2v2" />
            <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
            <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
            <circle cx="12" cy="12" r="1" fill="currentColor" />
            <line x1="12" y1="9" x2="12" y2="7" />
            <line x1="12" y1="15" x2="12" y2="17" />
            <line x1="9" y1="12" x2="7" y2="12" />
            <line x1="15" y1="12" x2="17" y2="12" />
          </svg>
          B-Box Search
        </button>
      </div>

      <!-- Filter panel (toggle via funnel icon) -->
      <div
        id="cv-dm-filter-panel"
        class="cv-dm-filter-panel"
        *ngIf="isFilterPanelOpen()"
        role="region"
        aria-label="Dataset filters"
        [attr.aria-busy]="filtersLoading()"
      >
        <div class="cv-dm-filter-panel__toolbar">
          <p class="cv-dm-filter-panel__hint" *ngIf="filtersLoading()">
            Loading filters…
          </p>
          <button
            type="button"
            class="cv-dm-filter-panel__clear-all"
            [disabled]="!hasActiveFilters() || filtersLoading()"
            (click)="clearAllFilters()"
          >
            Clear all
          </button>
        </div>
        <div class="cv-dm-filter-grid">
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="organisation"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Organisation"
              [disabled]="filtersLoading()"
              [options]="organisationOptionsModel()"
              [selectedItems]="selectedOrganisations()"
              (selectedItemsChange)="onOrganisationsFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="tags"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Tags"
              [disabled]="filtersLoading()"
              [options]="tagsOptionsModel()"
              [selectedItems]="selectedTags()"
              (selectedItemsChange)="onTagsFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="types"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select Organisation Type"
              [disabled]="filtersLoading()"
              [options]="typesOptionsModel()"
              [selectedItems]="selectedTypes()"
              (selectedItemsChange)="onTypesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="apiTypes"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="API Type"
              [disabled]="filtersLoading()"
              [options]="apiTypeOptionsModel"
              [selectedItems]="selectedApiTypes()"
              (selectedItemsChange)="onApiTypesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="accessPolicy"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Access policy"
              [disabled]="filtersLoading()"
              [options]="accessPolicyOptionsModel()"
              [selectedItems]="selectedAccessPolicies()"
              (selectedItemsChange)="onAccessPoliciesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="crs"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Select CRS"
              [disabled]="filtersLoading()"
              [options]="crsOptionsModel()"
              [selectedItems]="selectedCrs()"
              (selectedItemsChange)="onCrsFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
          <div class="cv-dm-filter-field">
            <lib-canvas-filter-multiselect
              panelKey="themes"
              [exclusiveOpenKey]="openFilterMultiselectKey()"
              (exclusivePanelChange)="
                onFilterMultiselectExclusiveChange($event)
              "
              placeholder="Themes Filter"
              [disabled]="filtersLoading()"
              [options]="themesOptionsModel()"
              [selectedItems]="selectedThemes()"
              (selectedItemsChange)="onThemesFilterChange($event)"
            ></lib-canvas-filter-multiselect>
          </div>
        </div>
      </div>

      <!-- Dataset list -->
      <div class="cv-dm-list" [attr.aria-busy]="loading()">
        <!-- Loading skeletons -->
        <ng-container *ngIf="loading()">
          <div
            class="cv-dm-item cv-dm-item--skeleton"
            *ngFor="let i of [1, 2, 3, 4, 5]"
          >
            <div class="cv-dm-item__row">
              <div class="cv-dm-item__info">
                <span class="cv-dm-skeleton cv-dm-skeleton--name"></span>
                <span class="cv-dm-skeleton cv-dm-skeleton--provider"></span>
              </div>
              <div class="cv-dm-item__actions">
                <span class="cv-dm-skeleton cv-dm-skeleton--badge"></span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Error state -->
        <div
          class="cv-dm-empty cv-dm-empty--error"
          *ngIf="!loading() && error()"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <p>{{ error() }}</p>
        </div>

        <!-- Dataset rows -->
        <ng-container *ngIf="!loading() && !error()">
          <div
            *ngFor="let dataset of datasets()"
            class="cv-dm-item"
            [class.cv-dm-item--expanded]="isExpanded(dataset.id)"
          >
            <div class="cv-dm-item__row">
              <div class="cv-dm-item__info">
                <span class="cv-dm-item__name">{{ dataset.name }}</span>
                <span class="cv-dm-item__provider">{{ dataset.provider }}</span>
              </div>
              <div class="cv-dm-item__actions">
                <span
                  class="cv-dm-item__badge cv-dm-item__badge--{{
                    dataset.access | lowercase
                  }}"
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="2" y1="12" x2="22" y2="12" />
                    <path
                      d="M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20"
                    />
                  </svg>
                  {{ dataset.access }}
                </span>
                <button
                  class="cv-dm-item__expand-btn"
                  [class.cv-dm-item__expand-btn--open]="isExpanded(dataset.id)"
                  (click)="toggleExpand(dataset.id)"
                  type="button"
                  [attr.aria-label]="
                    isExpanded(dataset.id) ? 'Collapse' : 'Expand'
                  "
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="cv-dm-item__detail" *ngIf="isExpanded(dataset.id)">
              <div class="cv-dm-item__detail-actions">
                <div class="cv-dm-item__detail-btns">
                  <lib-canvas-dataset-load-buttons
                    [dataset]="dataset"
                    (getAll)="onGetAllClick($event)"
                    (bboxFilter)="onBboxFilterClick($event)"
                    (attrFilter)="onAttrFilterClick($event)"
                    (getStacList)="onStacListClick($event)"
                    (loadTiles)="onLoadTilesClick($event)"
                  ></lib-canvas-dataset-load-buttons>
                </div>
                <div class="cv-dm-item__detail-icons">
                  <button
                    class="cv-dm-item__icon-btn"
                    title="Download"
                    type="button"
                    [disabled]="isDownloadBusy(dataset.id)"
                    (click)="
                      onDownloadDataset(dataset); $event.stopPropagation()
                    "
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </button>
                  <button
                    class="cv-dm-item__icon-btn"
                    title="Open in new tab"
                    type="button"
                    (click)="
                      openDatasetDetail(dataset.id); $event.stopPropagation()
                    "
                  >
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                      />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </button>
                </div>
              </div>

              <p
                class="cv-dm-item__access-msg"
                *ngIf="showsGetAllNoAccessMessage(dataset.id)"
              >
                You do not have access to this dataset. You will need to
                <button
                  type="button"
                  class="cv-dm-item__access-link"
                  (click)="
                    onRequestAccessClick(dataset.id); $event.stopPropagation()
                  "
                >
                  request access
                </button>
                to access this dataset.
              </p>

              <p
                class="cv-dm-item__access-msg"
                *ngIf="showsNoAccessMessage(dataset.id)"
              >
                User does not have access to this dataset. Please
                <button
                  type="button"
                  class="cv-dm-item__access-link"
                  (click)="
                    onRequestAccessClick(dataset.id); $event.stopPropagation()
                  "
                >
                  request access
                </button>
                to download.
              </p>

              <p
                class="cv-dm-item__access-msg"
                *ngIf="showsFileNotFoundMessage(dataset.id)"
              >
                File not found.
              </p>
            </div>
          </div>

          <div class="cv-dm-empty" *ngIf="datasets().length === 0">
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <p>No datasets match your search.</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <lib-canvas-request-access-modal
    [visible]="showRequestAccessModal()"
    [userHasOrganisation]="userHasOrganisation()"
    [organisationName]="organisationName()"
    [closeOnSubmit]="false"
    (visibleChange)="onRequestAccessModalVisibleChange($event)"
    (requestAccessSubmit)="onRequestAccessSubmit($event)"
  ></lib-canvas-request-access-modal>
</div>
